var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "raft-js-app-component"
    }
  }, [_vm.message ? [_c('div', {
    staticClass: "messages status messages--status"
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")])] : _vm._e(), _vm._v(" "), _vm.hasErrors ? [_vm._l(_vm.errors, function (error, index) {
    return _c('div', {
      key: 'error-' + index,
      staticClass: "messages error messages--error"
    }, [_vm._v("\n      " + _vm._s(error) + "\n    ")]);
  }), _vm._v(" "), _c('ErrorStateLinks')] : _vm._e(), _vm._v(" "), _vm.hasRoute ? _c('router-view', {
    on: {
      "form-error-message": _vm.addError,
      "form-message": _vm.setMessage
    }
  }) : _vm._e(), _vm._v(" "), _vm.hasSlot ? _vm._t("default") : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }